/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Edit_Privacy_TitleInputs */

const en_admin_edit_privacy_title = /** @type {(inputs: Admin_Edit_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data privacy`)
};

const de_admin_edit_privacy_title = /** @type {(inputs: Admin_Edit_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

/**
* | output |
* | --- |
* | "Data privacy" |
*
* @param {Admin_Edit_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_edit_privacy_title = /** @type {((inputs?: Admin_Edit_Privacy_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Edit_Privacy_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_edit_privacy_title(inputs)
	return en_admin_edit_privacy_title(inputs)
});